/* eslint-disable react/no-unescaped-entities */
import LinkedIn from '../assets/socials/linkedin.svg';

import GitHub from '../assets/socials/github.svg';

import { TypeAnimation } from 'react-type-animation';

// motion
import { motion } from 'framer-motion';
// variants
import { transition1 } from '../transitions';

import WomenImg from '../img/about/kamesh.png';

import { useContext } from 'react';
import { CursorContext } from '../context/CursorContext';

const Home = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <motion.section
      initial={{ opacity: 0, y: window.innerWidth }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: window.innerWidth }}
      transition={transition1}
      className="section hero"
    >
      <div className="continer mx-auto h-full   relative">
        <div className="flex flex-col lg:flex-row h-full items-center justify-center gap-x-20 text-center md:gap-x-12 md:mx-10 lg:text-center pt-24 lg:pt-36 pb-8">
          <motion.div
            className="flex flex-col lg:items-start text-gray-800"
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
            initial={{ x: -1000 }}
            animate={{ x: 0 }}
            transition={{
              duration: '2',
              delay: '1',
            }}
          >
            <h2 className="h2 ">
              I'm KAMESHWARAN E , <br />
            </h2>
            <h1 className="h2"> Full Stack Developer</h1>
            <TypeAnimation
              className="sm:text-xl italic font-semibold text-transparent leading-10 bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600"
              sequence={[
                // Same substring at the start will only be typed once, initially
                'Ready to embark on the world of web development.',
                1000,
                'Eager to learn and adapt to new technologies',
                1000,
                'Excited to contribute to real-world projects.',
                1000,
                'Grow as a valued member of a collaborative team.',
                1000,
              ]}
              speed={40}
              // style={{ fontSize: '1.2em' }}
              repeat={Infinity}
            />
            {/* hero info */}
            <p className="mb-17 text-light text-primary  text-base lg:text-xl  text-center">
              "The journey of a thousand commits begins with a single 'Hello,
              World!'"
            </p>
            <a
              href="https://rxresu.me/kamesh1620/kameshwaran"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="btn my-3.5">Hire Me</button>
            </a>
          </motion.div>
          <br />
          <div className="grid grid-cols lg:gap-1.5">
            <div className="max-w-[250px] lg:max-w-[420px] h-[240px] lg:h-[420px]  overflow-hidden">
              <motion.img
                className="object-cover h-fulllg:h-[420px] hover:scale-110  transition-all duration-500 rounded-3xl"
                src={WomenImg}
                alt=""
                whileHover={{ scale: 1.1 }}
                transition={transition1}
              />
            </div>
          </div>
        </div>

        {/* hero socials */}
        <div
          className="bg-white w-15  rounded-6xl py-1 px-1 absolute left-0 top-48 hidden md:block"
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
        >
          <div className="my-1">
            <a
              href="https://www.linkedin.com/in/kameshwaran-e-10350a22b/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 block rounded transition-all duration-500"
            >
              <img src={LinkedIn} alt="" className="w-10 h-10" />
            </a>
          </div>

          <div className="my-1">
            <a
              href="https://github.com/Kameshwaran-E"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 block rounded transition-all duration-500"
            >
              <img src={GitHub} alt="" className="w-10 h-10" />
            </a>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Home;
